// extracted by mini-css-extract-plugin
export default {"section":"FormSection_section__Cj1Ox","header":"FormSection_header__ckSoJ","action":"FormSection_action__Da0DN","body":"FormSection_body__HXiFB"};